import React, { useState } from 'react';
import '../css/editResume.css';

const cleanHTML = (html) => {
  if (!html) return '';
  return html.replace(/<[^>]+>/g, '').trim(); // strip all tags
};

const EditResume = ({ formData, setFormData }) => {
  const [selectedWorkIndex, setSelectedWorkIndex] = useState(null);
  const [selectedEducationIndex, setSelectedEducationIndex] = useState(null);

  const handleSelectWorkHistory = (index) => {
    setSelectedWorkIndex(index !== null ? index : null);
  };

  const handleSelectEducation = (index) => {
    setSelectedEducationIndex(index !== null ? index : null);
  };

  const handleArrayFieldChange = (field, index, value) => {
    const updatedWorkHistory = [...formData.workHistory];
    if (selectedWorkIndex !== null) {
      const fieldArray = updatedWorkHistory[selectedWorkIndex][field] || [];
      fieldArray[index] = value;
      updatedWorkHistory[selectedWorkIndex][field] = fieldArray;
      setFormData({ ...formData, workHistory: updatedWorkHistory });
    }
  };

  const handleDeleteArrayFieldItem = (field, index) => {
    const updatedWorkHistory = [...formData.workHistory];
    if (selectedWorkIndex !== null) {
      const fieldArray = updatedWorkHistory[selectedWorkIndex][field] || [];
      fieldArray.splice(index, 1);
      updatedWorkHistory[selectedWorkIndex][field] = fieldArray;
      setFormData({ ...formData, workHistory: updatedWorkHistory });
    }
  };

  const handleEnhancedProjectsChange = (index, value) => {
    setFormData((prevFormData) => {
      const updatedEducationHistory = [...prevFormData.educationHistory];
      if (selectedEducationIndex !== null && updatedEducationHistory[selectedEducationIndex]) {
        const enhancedProjects = [...(updatedEducationHistory[selectedEducationIndex].enhancedProjects || [])];
        enhancedProjects[index] = value;
        updatedEducationHistory[selectedEducationIndex].enhancedProjects = enhancedProjects;
      }
      return { ...prevFormData, educationHistory: updatedEducationHistory };
    });
  };

  const handleDeleteEnhancedProject = (index) => {
    const updatedEducationHistory = [...formData.educationHistory];
    if (selectedEducationIndex !== null) {
      const enhancedProjects = updatedEducationHistory[selectedEducationIndex].enhancedProjects || [];
      enhancedProjects.splice(index, 1);
      updatedEducationHistory[selectedEducationIndex].enhancedProjects = enhancedProjects;
      setFormData({ ...formData, educationHistory: updatedEducationHistory });
    }
  };

  const handleClearAllEnhancedProjects = () => {
    const updatedEducationHistory = [...formData.educationHistory];
    if (selectedEducationIndex !== null) {
      updatedEducationHistory[selectedEducationIndex].enhancedProjects = [];
      setFormData({ ...formData, educationHistory: updatedEducationHistory });
    }
  };

  return (
    <div>
      <h2 className="edit-heading edit-h2">Edit Resume</h2>

      <h3 className="edit-heading edit-h3">Select Work History Entry</h3>
      <select onChange={(e) => handleSelectWorkHistory(parseInt(e.target.value, 10))}>
        <option value="">Select Entry</option>
        {formData.workHistory.map((work, index) => (
          <option key={index} value={index}>
            {work.jobTitle} at {work.employer}
          </option>
        ))}
      </select>

      {selectedWorkIndex !== null && formData.workHistory[selectedWorkIndex] && (
        <div>
          <h4 className="edit-heading edit-h4">Edit Enhanced Responsibilities</h4>
          {(formData.workHistory[selectedWorkIndex].enhancedResponsibilities || []).map((item, index) => (
            <div key={index} className="resume-edit-row">
              <textarea
                className="resume-textarea"
                value={cleanHTML(item)}
                onChange={(e) =>
                  handleArrayFieldChange('enhancedResponsibilities', index, e.target.value)
                }
              />
              <button onClick={() => handleDeleteArrayFieldItem('enhancedResponsibilities', index)}>
                Delete
              </button>
            </div>
          ))}

          <h4 className="edit-heading edit-h4">Edit Enhanced Accomplishments</h4>
          {(formData.workHistory[selectedWorkIndex].enhancedAccomplishments || []).map((item, index) => (
            <div key={index} className="resume-edit-row">
              <textarea
                className="resume-textarea"
                value={cleanHTML(item)}
                onChange={(e) =>
                  handleArrayFieldChange('enhancedAccomplishments', index, e.target.value)
                }
              />
              <button onClick={() => handleDeleteArrayFieldItem('enhancedAccomplishments', index)}>
                Delete
              </button>
            </div>
          ))}
        </div>
      )}

      <h3 className="edit-heading edit-h3">Select Education Entry</h3>
      <select onChange={(e) => handleSelectEducation(parseInt(e.target.value, 10))}>
        <option value="">Select Entry</option>
        {formData.educationHistory.map((edu, index) => (
          <option key={index} value={index}>
            {edu.institution}
          </option>
        ))}
      </select>

      {selectedEducationIndex !== null && formData.educationHistory[selectedEducationIndex] && (
        <div>
          <h4 className="edit-heading edit-h4">Edit Significant Projects</h4>
          {(formData.educationHistory[selectedEducationIndex].enhancedProjects || []).map((item, index) => (
            <div key={index} className="resume-edit-row">
              <textarea
                className="resume-textarea"
                value={cleanHTML(item)}
                onChange={(e) => handleEnhancedProjectsChange(index, e.target.value)}
              />
              <button onClick={() => handleDeleteEnhancedProject(index)}>Delete</button>
            </div>
          ))}
          <button
            onClick={handleClearAllEnhancedProjects}
            style={{ marginTop: '10px', backgroundColor: 'red', color: 'white', padding: '5px 10px' }}
          >
            Clear All Projects
          </button>
        </div>
      )}
    </div>
  );
};

export default EditResume;
